import { getDefaultStore } from "jotai";
import { Api } from './Api';
import { ApiUrl } from './ApiUrl';
import { Dataset, DatasetImage, DatasetCreateReq, DatasetImageObjectAddReq, DatasetImageAddResp, ObbAnnotation } from "./Application";
import { authAtom } from "../Atoms";

export const DatasetApi = {
    getDatasets: async (): Promise<Dataset[]> => {
        const result = await Api.datasetList();
        if( result.isOk ) {
            return result.value;
        }
        throw new Error( result.error );
    },

    createDataset: async ( data: { name: string; description?: string; } ): Promise<Dataset> => {
        const result = await Api.datasetCreate( data as DatasetCreateReq );
        if( result.isOk ) {
            return result.value;
        }
        throw new Error( result.error );
    },

    getImages: async ( datasetId: number ): Promise<DatasetImage[]> => {
        const result = await Api.datasetImageList( datasetId );
        if( result.isOk ) {
            return result.value;
        }
        throw new Error( result.error );
    },

    uploadImage: async ( datasetId: number, files: File[] ): Promise<DatasetImageAddResp> => {
        const store = getDefaultStore();
        const auth  = store.get( authAtom );
        const token = auth.token;
        const form = new FormData();
        files.forEach( f => form.append( 'files', f ) );

        const resp = await fetch( ApiUrl.DatasetBulkUpload( datasetId ), {
            method: 'POST',
            headers: token ? { 'Authorization': `Bearer ${token}` } : undefined,
            body: form
        } );
        if( !resp.ok ) {
            throw new Error( `Upload failed: ${resp.statusText}` );
        }
        const result = await resp.json();
        return result as DatasetImageAddResp;
    },

    getAnnotations: async ( imageId: number ): Promise<ObbAnnotation[]> => {
        const result = await Api.datasetImageObjectList( imageId );
        if( result.isOk ) {
            return result.value;
        }
        throw new Error( result.error );
    },

    addAnnotation: async ( imageId: number, data: Omit<ObbAnnotation, 'annotationId' | 'datasetImageId'> ): Promise<ObbAnnotation> => {
        const result = await Api.datasetImageObjectAdd( imageId, data as DatasetImageObjectAddReq );
        if( result.isOk ) {
            return result.value;
        }
        throw new Error( result.error );
    },

    updateAnnotation: async ( id: number, data: Partial<ObbAnnotation> ): Promise<ObbAnnotation> => {
        const result = await Api.datasetImageObjectEdit( id, data as DatasetImageObjectAddReq );
        if( result.isOk ) {
            return result.value;
        }
        throw new Error( result.error );
    },

    deleteAnnotation: async ( id: number ): Promise<void> => {
        const result = await Api.datasetImageObjectDelete( id );
        if( result.isOk ) {
            //don't do anything
            return;
        }
        throw new Error( result.error );
    },
};